import React, { useState } from 'react';
import { Link as RouterLink, useHistory } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import {
  deleteSite,
  leaveSiteContactship,
  selectSiteById,
  selectSitesState,
} from '../../redux/slices/sitesSlice';
import ConfirmDialog from '../../components/ConfirmDialog';
import FormDialog from '../../components/FormDialog';
import SiteForm from './SiteForm';
import { useBodyStyles } from '../../styles/muiStyles';
import { Menu, IconButton, MenuItem, Collapse, List, ListItem, ListItemIcon, ListItemText, Dialog, useMediaQuery, useTheme } from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import AddIcon from '@material-ui/icons/AddCircle';
import StopIcon from '@material-ui/icons/CancelOutlined';
import ReplaceIcon from '@material-ui/icons/PublishOutlined';
import OpenInNewIcon from '@material-ui/icons/OpenInNew';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import GroupAddOutlinedIcon from '@material-ui/icons/GroupAddOutlined';
import DevOff from '@material-ui/icons/PowerOffRounded';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import DeleteOutlineIcon from '@material-ui/icons/DeleteOutline';
import DeleteForeverIcon from '@material-ui/icons/DeleteForeverOutlined';
import DeleteIcon from '@material-ui/icons/DeleteOutlined';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOffOutlined';
import CommentOutlinedIcon from '@material-ui/icons/CommentOutlined';
import StorageIcon from '@material-ui/icons/Storage';
import { RootState } from '../../redux/store';
import ConcModForm from './ConcModForm';
import { ReportProblemOutlined } from '@material-ui/icons';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import makeStyles from '@material-ui/core/styles/makeStyles';
import CarnetDeBord from './CarnetDeBord';
import FormDialogMedium from '../../components/FormDialogMedium';
import FormDialogBiggy from '../../components/FormDialogBiggy';

const useStyles = makeStyles((theme) => ({
  root: {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper
  },
  rootNoTopPad: {
    '&': {
      width: "100%",
      maxWidth: 360,
      backgroundColor: theme.palette.background.paper,
      paddingTop: 0,
    },
    'div svg': {
      height: '1em',
      width: '1em',
    },
  },
  nested: {
      paddingLeft: theme.spacing(4)
  },
  nestedSecondLevel: {
      paddingLeft: theme.spacing(8)
  }
}));
interface SitesMenuProps {
  siteId: string;
  sn_site: string;
  iconSize?: 'small' | 'default' | 'large';
}

const SitesMenu: React.FC<SitesMenuProps> = ({
  siteId,
  sn_site,
//  contacts,
  iconSize,
}) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const classes2 = useStyles();
  const [open1, setOpen1] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [openSecondLevel, setOpenSecondLevel] = useState(true);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down('md'));
  const theSite = useSelector((state: RootState) =>
    selectSiteById(state, siteId)
  );
  const sites = useSelector((state: RootState) =>
    selectSitesState(state)
  );
//  const modzArray = [{ conc: "", modz: []}]
  const modzArray: string[] = []
  theSite?.concentrateur.map((c,index) => {
    //modzArray.push( conc: String(c.hardSn), modz: Array(c.modules.map((m)=> m)))
    //modzArray[index].conc = String(c.hardSn)
    modzArray.push(c.modules.join(','))
//    c.modules.map((m)=> modzArray[index].modz.push(String(m)))
//    modzArray[index].modz = Array(c.modules.map((m)=> m))
  })
  let notes: [] //{ siteId: string, date: Date, note: string }[]
  const currSites = sites.sites.filter((s)=>Number(s.sn_site) === Number(sn_site))
  const handleClick1 = () => {
    setOpen1(!open1);
  };
  const handleClick2 = () => {
    setOpen2(!open2);
  };
  const handleClickSecondLevel = () => {
    setOpenSecondLevel(!openSecondLevel);
  };
  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };
  const handleDeleteSite = () => {
    dispatch(deleteSite(siteId, history));
  };
  const handleLeaveSite = () => {
    dispatch(leaveSiteContactship(siteId, history));
  };

  return (
    <div>
      <IconButton onClick={handleOpenMenu} size="small">
        <MoreHorizIcon color="primary" fontSize={iconSize || 'large'} />
      </IconButton>
      <Menu
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        marginThreshold={8}
        elevation={4}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
        <List
          component="nav"
          aria-labelledby="nested-list-subheader"
          className={classes2.rootNoTopPad}>
          <MenuItem
            onClick={handleCloseMenu}
            component={RouterLink}
            //to={`/sites/${siteId}`}
            to={`/logement/${sn_site}/${siteId}`}
          >
            <EditOutlinedIcon style={{ marginRight: '10px' }} />
            Gérer le logement
          </MenuItem>
          <ListItem button onClick={handleClick1}>
          <ListItemIcon>
              <StorageIcon />
          </ListItemIcon>
          <ListItemText primary="Concentrateurs" />
          {open1 ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open1} timeout="auto" unmountOnExit>
          <List component="div" disablePadding className={classes2.nested}>
            <FormDialog
              triggerBtn={{
                type: 'menu',
                icon: AddIcon,
                text: 'Ajouter un concentrateur',
                iconStyle: { marginRight: '10px' },
                closeMenu: handleCloseMenu,
              }}
              title="Ajouter un concentrateur"
            >
              <ConcModForm
                editMode="AddConc"
                currentConcentrateurs={theSite?.concentrateur/*.map((c)=>String(c.hardSn))*/}
                currentModules={modzArray}
                siteId={siteId}
              />
            </FormDialog>
            <FormDialog
              triggerBtn={{
                type: 'menu',
                icon: EditOutlinedIcon,
                text: 'Tél SIM / WIFI',
                iconStyle: { marginRight: '10px' },
                closeMenu: handleCloseMenu,
              }}
              title="Tél SIM / WIFI"
            >
            <ConcModForm
                editMode="TelConc"
                currentConcentrateurs={theSite?.concentrateur/*.map((c)=>String(c.hardSn))*/}
                currentModules={modzArray}
                siteId={siteId}
              />
            </FormDialog>
            <FormDialog
              triggerBtn={{
                type: 'menu',
                icon: StopIcon,
                text: 'Arrêter un concentrateur',
                iconStyle: { marginRight: '10px' },
                closeMenu: handleCloseMenu,
              }}
              title="Arrêter un concentrateur"
            >
              <ConcModForm
                editMode="StopConc"
                currentConcentrateurs={theSite?.concentrateur/*.map((c)=>String(c.hardSn))*/}
                currentModules={modzArray}
                siteId={siteId}
              />
            </FormDialog>
            <FormDialog
              triggerBtn={{
                type: 'menu',
                icon: ReplaceIcon,
                text: 'Remplacer un concentrateur',
                iconStyle: { marginRight: '10px' },
                closeMenu: handleCloseMenu,
              }}
              title="Remplacer un concentrateur"
            >
              <ConcModForm
                editMode="ReplaceConc"
                currentConcentrateurs={theSite?.concentrateur/*.map((c)=>String(c.hardSn))*/}
                currentModules={modzArray}
                siteId={siteId}
              />
            </FormDialog>
          </List>
          </Collapse>
          <ListItem button onClick={handleClick2}>
            <ListItemIcon>
                <StorageIcon />
            </ListItemIcon>
            <ListItemText primary="Modules" />
            {open2 ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={open2} timeout="auto" unmountOnExit>
            { /*!currentData?.app_date_end*/ true ?
            <List component="div" disablePadding className={classes2.nested}>
            <FormDialog
              triggerBtn={{
                type: 'menu',
                icon: AddIcon,
                text: 'Ajouter un module',
                iconStyle: { marginRight: '10px' },
                closeMenu: handleCloseMenu,
              }}
              title="Ajouter un module"
            >
              <ConcModForm
                editMode="AddModule"
                currentConcentrateurs={theSite?.concentrateur/*.map((c)=>String(c.hardSn))*/}
                currentModules={modzArray}
                siteId={siteId}
              />
            </FormDialog>
            <FormDialog
              triggerBtn={{
                type: 'menu',
                icon: StopIcon,
                text: 'Arrêter un module',
                iconStyle: { marginRight: '10px' },
                closeMenu: handleCloseMenu,
              }}
              title="Arrêter un module"
            >
              <ConcModForm
                editMode="StopModule"
                currentConcentrateurs={theSite?.concentrateur/*.map((c)=>String(c.hardSn))*/}
                currentModules={modzArray}
                siteId={siteId}
              />
            </FormDialog>
            <FormDialog
              triggerBtn={{
                type: 'menu',
                icon: ReplaceIcon,
                text: 'Remplacer un module',
                iconStyle: { marginRight: '10px' },
                closeMenu: handleCloseMenu,
              }}
              title="Remplacer un module"
            >
              <ConcModForm
                editMode="ReplaceModule"
                currentConcentrateurs={theSite?.concentrateur/*.map((c)=>String(c.hardSn))*/}
                currentModules={modzArray}
                siteId={siteId}
              />
            </FormDialog>
          </List>
            :null }
        </Collapse>
      </List>
      <FormDialogBiggy
        triggerBtn={{
          type: 'menu',
          icon: AddIcon,
          text: 'Notes de suivi',
          iconStyle: { marginRight: '10px' },
          closeMenu: handleCloseMenu,
        }}
        title={"Notes de suivi du logement "+sn_site}
      >
        <CarnetDeBord
          editMode="EditNote"
          //currentSites={currSites}
/*          currentNotes={[Array(sites.sites.filter((s)=>s.sn_site === sn_site).map((r)=>r.id)),
            Array(sites.sites.filter((s)=>s.sn_site === sn_site).map((r)=>r.date_update)),
            Array(sites.sites.filter((s)=>s.sn_site === sn_site).map((r)=>r.rq_instru))]}*/
          siteId={siteId}
          siteSn={sn_site}
        />
      </FormDialogBiggy>
    </Menu>
  </div>
  );
};

export default SitesMenu;
